import { Base, Text, View } from 'components';
import { Config } from 'components/Base';
import React from 'react';
import styles from './index.module.scss';

interface State {
  
}

export default class ScoresRule extends Base {
  public config: Config = {
    navigationBarTitleText: '积分规则'
  };

  public state: State = {
    
  };

  public render() {
    const {  } = this.state;

    return (
      <View className={styles.container}>
        <View className={styles.panel}>
          <Text className={styles.title}>积分使用规则</Text>
          <View className={styles.card}>
            <Text className={styles.cardTitle}>
              <Text className={styles.mark}>·</Text>每天一次免积分拨打机会，规则如下：
            </Text>
            <View className={styles.cardContent}>
              <Text className={styles.cardContentText}>
                1、仅限长期工作免积分，但是
                <Text className={styles.red}>
                不包括【高工资+上保险的】
                </Text>
                ，免得抢了积分用户的机会！其它都是每天免积分一次 
              </Text>
              
            </View>
            <View className={styles.cardContent}>
              <Text className={styles.cardContentText}>
                2、
                <Text className={styles.red}>
                  替班
                </Text>
                时效性太强，不提供免积分拨打，不然买了替班的会员会有意见！
              </Text>
              
            </View>
            
          </View>
          <View className={this.cx(styles.card, styles.noBorder)}>
            <Text className={styles.cardTitle}>
              <Text className={styles.mark}>·</Text>
              拨打简历电话
            </Text>
            <View className={styles.cardContent}>
              <Text className={styles.cardContentText}>
                每天可免积分拨打电话1次，
                <Text className={styles.red}>增加1次消耗5积分</Text>
              </Text>
            </View>
          </View>
        </View>
        
      </View>
    );
  }
}
